import html from './unavailabilityHistoryScreen.html';

class HistoryController {
  constructor(
    Authentication,
    PersonaCollection,
    AvailabilityUtils,
    UserUtils,
    $timeout,
    $state,
    $scope,
    $location,
    $window
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      AvailabilityUtils,
      UserUtils,
      $timeout,
      $state,
      $scope,
      $location,
      $window,
    });

    this.unavailabilitySets = [];
  }

  $onInit() {
    this.user = null;
    this.init();
  }

  init() {
    const userId = this.$state.params.userId;
    this.user = this.PersonaCollection.personasDict[userId];
  }

  getProfileSref() {
    return `users.profile({ userId: ${this.user.id}, tab: "availability" })`;
  }

  getUnavailabilityId() {
    return this.$state.params.unavailabilityId;
  }

  setUnavailabilityData(data) {
    this.unavailabilitySets = data;
  }

  get isManager() {
    return this.Authentication.user.isManager;
  }

  get shouldRequest() {
    return this.AvailabilityUtils.shouldRequest();
  }

  get submitDisabled() {
    return !this.AvailabilityUtils.canSaveSets(this.unavailabilitySets);
  }

  async submit() {
    if (this.form.$invalid) {
      throw new Error('invalid form');
    }

    await this.AvailabilityUtils.saveAvailability(this.unavailabilitySets);
    this.form.$setPristine();
    this.close();
  }

  close() {
    this.$window.history.back();
  }
}

export default {
  templateUrl: html,
  controller: HistoryController,
  controllerAs: 'ctrl',
};
